import React from 'react';
import { Button, Input, Modal } from 'antd';
import './index.scss';

const PCOpenTrialSuccess = ({ visible, onClose, time }: any) => {
  return <Modal centered visible={visible} onCancel={onClose} closable={false} footer={null} width={368}>
    <div style={{ paddingBottom: 30, textAlign: 'center' }}>
    <div style={{ marginBottom: 19,paddingTop:9 }}>
        <img src={require('../../assets/new-trial/success.svg')} width={64}/>
      </div>
      <div style={{ fontWeight: 600, fontSize: 20, marginBottom: 12,color:'#2F2F2F'}}>账号开通成功</div>
      <div style={{ fontWeight: 500, fontSize: 16,color:'#7A8087'}}>请查收邮件激活账号，您的体验会员时长为 {time} 天，请及时登录使用</div>
    </div>
    <div className={'islide-pc-trial-modal-success-footer'}>
      <Button  onClick={onClose}>确定</Button>
    </div>
  </Modal>;
};

export default PCOpenTrialSuccess;
